"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILCourseSelectionCard = void 0;
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var enums_1 = require("../../shared/enums");
var il_button_1 = require("../il-button/il-button");
var il_custom_icon_1 = require("../il-custom-icon/il-custom-icon");
var il_highlight_tile_1 = require("../il-highlight-tile/il-highlight-tile");
var ILCourseSelectionCard = function (_a) {
    var iconType = _a.iconType, sx = _a.sx, title = _a.title, subtitle = _a.subtitle, _b = _a.limitText, limitText = _b === void 0 ? false : _b, _c = _a.active, active = _c === void 0 ? false : _c, className = _a.className, externalOnClick = _a.onClick, props = __rest(_a, ["iconType", "sx", "title", "subtitle", "limitText", "active", "className", "onClick"]);
    var classes = 'il-card ' + (className || '');
    var _d = react_1.default.useState(active), selected = _d[0], setSelected = _d[1];
    function onClick() {
        setSelected(!selected);
        externalOnClick && externalOnClick();
    }
    var splittedText = limitText && props.description && props.description.length > 240
        ? "".concat(props.description.substring(0, 240), "...")
        : props.description;
    return (react_1.default.createElement(il_highlight_tile_1.ILHighlightTile, __assign({ component: 'div', role: undefined, disableRipple: true, className: classes,
        sx: __assign({ backgroundColor: 'background.default', position: 'relative', p: selected ? 2.5 : 3, borderRadius: '0.25rem' }, sx),
        active: selected }, props),
        react_1.default.createElement(material_1.Grid, { container: true, flexDirection: "column" },
            react_1.default.createElement(material_1.Grid, { item: true, container: true, flexDirection: "row", wrap: "nowrap", justifyContent: "space-between", sx: { mb: 2 } },
                react_1.default.createElement(material_1.Grid, { item: true, container: true, flexDirection: "row", wrap: "nowrap" },
                    react_1.default.createElement(material_1.Grid, { item: true },
                        react_1.default.createElement(il_custom_icon_1.ILCustomIcon, { type: iconType, size: props.iconSize, icon: props.customIcon })),
                    react_1.default.createElement(material_1.Grid, { item: true, container: true, flexDirection: "column", sx: { ml: 1.5, mr: '1px' } },
                        react_1.default.createElement(material_1.Typography, { variant: "subtitle1", sx: {
                                fontSize: 12,
                                lineHeight: 1,
                                color: 'text.secondary',
                            } }, title),
                        react_1.default.createElement(material_1.Typography, { variant: "subtitle2", sx: {
                                fontSize: 14,
                                color: 'text.primary',
                                mt: '1.2px',
                                fontWeight: 600,
                                textAlign: 'left',
                            } }, subtitle))),
                react_1.default.createElement(material_1.Grid, { item: true },
                    react_1.default.createElement(il_button_1.ILButton, { variant: selected ? enums_1.ButtonVariantEnum.TEXT : enums_1.ButtonVariantEnum.OUTLINED, onClick: onClick, sx: {
                            maxWidth: '100%',
                            whiteSpace: 'nowrap',
                            px: 2,
                            py: 0.5,
                            gap: 4,
                            width: 75,
                            borderRadius: '12rem',
                        } }, selected ? react_1.default.createElement(react_1.default.Fragment, null, "Remove") : react_1.default.createElement(react_1.default.Fragment, null, "+ Add")))),
            react_1.default.createElement(material_1.Grid, { item: true, flexDirection: "column" },
                react_1.default.createElement(material_1.Typography, { sx: { color: 'text.primary' } }, splittedText),
                props.children))));
};
exports.ILCourseSelectionCard = ILCourseSelectionCard;
